import { render, staticRenderFns } from "./uploadFile_direct.vue?vue&type=template&id=54d65c8d&scoped=true&"
import script from "./uploadFile_direct.vue?vue&type=script&lang=js&"
export * from "./uploadFile_direct.vue?vue&type=script&lang=js&"
import style0 from "./uploadFile_direct.vue?vue&type=style&index=0&id=54d65c8d&prod&lang=css&"
import style1 from "./uploadFile_direct.vue?vue&type=style&index=1&id=54d65c8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d65c8d",
  null
  
)

export default component.exports